// import React from "react";
// import { Routes, Route } from "react-router-dom";
// import HomePage from "./pages/HomePage";
// import Navbar from "./components/Navbar";
// import Spinner from './shared/Spinner'
// import HowToRegister from "./pages/HowToRegister";
// // import { Footer } from "./components/Footer";
// // import Calculater from "./pages/Calculater"
// function App() {
//   return (
//     <>
//       {/* <Calculater></Calculater> */}
//       {/* <Spinner />
//       <Navbar />
//       <Routes>
//         <Route path="/" exact element={<HomePage />} />
//         <Route path="/forVoters/how-to-register" element={<HowToRegister />} />
//       </Routes>
//       <Footer /> */}
//     </>
//   );
// }

// export default App;
import React, { useState } from 'react';
import Calculator from './pages/Calculater';
import Calculator17 from './pages/Calculater17';
import Pension from './pages/Pension';

function App() {
  const [page, setPage] = useState('1to16');

  return (
    <div>
      {/* Navbar */}
      <nav className="navbar navbar-expand-lg navbar-dark bg-primary">
        <div className="container-fluid">
          <a className="navbar-brand" href="/">Salary Calculator</a>

          {/* Toggler button for mobile */}
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          {/* Collapsible content */}
          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
              <li className="nav-item">
                <button
                  className={`nav-link btn btn-link text-white ${page === '1to16' ? 'fw-bold' : ''}`}
                  onClick={() => setPage('1to16')}
                >
                  1 to 16
                </button>
              </li>
              <li className="nav-item">
                <button
                  className={`nav-link btn btn-link text-white ${page === '17plus' ? 'fw-bold' : ''}`}
                  onClick={() => setPage('17plus')}
                >
                  17 and Above
                </button>
              </li>
              <li className="nav-item">
                <button
                  className={`nav-link btn btn-link text-white ${page === 'pension' ? 'fw-bold' : ''}`}
                  onClick={() => setPage('pension')}
                >
                  Pension
                </button>
              </li>
            </ul>
          </div>
        </div>
      </nav>

      {/* Page Content */}
      {page === '1to16' && <Calculator />}
      {page === '17plus' && <Calculator17 />}
      {page === 'pension' && <Pension />}
    </div>
  );
}

export default App;

